import type { Tool } from '@/hooks/useToolManagement/useGetTools'

export function getEarliestCreatedAt(tools: Tool[]): Nullable<string> {
  if (tools.length === 0) return null

  const dates = tools
    .map(tool => tool.created_at)
    .filter((date): date is string => date !== null && date !== undefined)
    .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())

  return dates.length > 0 ? dates[0] : null
}
